import { Component, OnInit } from '@angular/core';
import { AuthenService } from '@src/app/core/authen/authen.service';
import { SessionService } from '@src/app/core/session.service';
import { UrlParam } from '@src/app/shared/enums/url-param.enum';
import { FormUtils } from '@src/app/shared/utils/form-utils';
import { StringUtils } from '@src/app/shared/utils/string-utils';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
})
export class AuthenticationComponent implements OnInit {
  constructor(
    public authenService: AuthenService,
    public sessionService: SessionService
  ) {}

  ngOnInit(): void {
    const elementorPreview = StringUtils.getParamFromUrl(
      UrlParam.ElementorPreview
    );
    
    this.authenService.isLogin().subscribe((isLogin) => {
      if (isLogin || elementorPreview) return;
      this.goToLogin();
    });
  }

  goToLogin(): void {
    this.sessionService.setLoginCallBackpage(location.href);
    FormUtils.navigateTo(
      this.sessionService.appendLanguagePath(environment.jipUrl.login)
    );
  }
}
